/** 合并全局入口与窗口的汇总请求；查询期间的新事件触发后续查询，避免覆盖最新未读。 */
export function createChatUnreadSync({ readIdentity, request, onCount }) {
  let active = null;
  return {
    invalidate() { active = null; },
    refresh() {
      const identity = readIdentity();
      if (!identity) { active = null; onCount(0); return Promise.resolve(); }
      if (active?.identity === identity) { active.pending = true; return active.promise; }
      const entry = { identity, pending: true };
      active = entry;
      entry.promise = Promise.resolve().then(async () => {
        while (entry.pending && active === entry && readIdentity() === identity) {
          entry.pending = false;
          const response = await request();
          if (active !== entry || readIdentity() !== identity) return;
          const summary = response?.data;
          if (Number(response?.code) !== 200 || !summary
            || ![summary.legacyUnread, summary.customerServiceUnread, summary.totalUnread].every(n => Number.isSafeInteger(n) && n >= 0)
            || !Number.isSafeInteger(summary.workflowUnread ?? 0) || (summary.workflowUnread ?? 0) < 0
            || summary.totalUnread !== summary.legacyUnread + summary.customerServiceUnread + (summary.workflowUnread ?? 0)) {
            throw new Error("消息未读汇总无效");
          }
          // 后续事件已到达时跳过旧快照，直接再查最新水位。
          if (!entry.pending) onCount(summary.totalUnread, summary);
        }
      }).finally(() => { if (active === entry) active = null; });
      return entry.promise;
    },
  };
}
